import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { SelectField, SelectFieldProps } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { createOption } from '@mews-commander/ui';
import { ProcessPaymentFormField } from '../forms/ProcessPayment/ProcessPaymentFormSchema';

interface CurrencySelectFieldProps extends Omit<SelectFieldProps, 'name' | 'options' | 'label' | 'required'> {
    currencies: string[];
}

export const CurrencySelectField = ({ currencies, ...props }: CurrencySelectFieldProps) => {
    const options = pipe(
        currencies,
        array.map((c) => createOption({ value: c, label: c }))
    );

    return (
        <SelectField
            {...props}
            required
            name={ProcessPaymentFormField.CurrencyCode}
            label={lt('Currency')}
            options={options}
        />
    );
};
